import { merge } from 'lodash';
import Vue from 'vue';

import actionFactory from '../../lib/actionFactory';

export default {
  ...actionFactory({
    singular: 'invoiceValidation',
    plural: 'invoiceValidations',
    url: 'invoice-validation'
  }),
  getQueue: async ({ commit, state }, { data }) => {
    // Ignore any state.listFilters that are undefined or null
    const filters = Object.entries(state.listFilters).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {});

    data.params = merge({}, filters, data.params || {});

    try {
      commit('GET_QUEUE_REQUEST', { data });
      const { body } = await Vue.http.get(`${process.env.VUE_APP_API_URL}/invoice-validation/queue`, data);
      commit('GET_QUEUE_SUCCESS', { body });
      return body;
    } catch (e) {
      commit('GET_QUEUE_ERROR', e.body);
      console.log(e);
      return e;
    }
  },
  getExport: async ({ commit }, { id }) => {
    try {
      commit('GET_EXPORT_REQUEST', { id });
      const { body } = await Vue.http.get(`${process.env.VUE_APP_API_URL}/invoice-validation/${id}/export`);
      commit('GET_EXPORT_SUCCESS', { body, id });
      return body;
    } catch (e) {
      commit('GET_EXPORT_ERROR', e.body);
      console.log(e);
      return e;
    }
  },
  revalidate: async ({ commit }, { id }) => {
    try {
      commit('REVALIDATE_REQUEST', { id });
      const { body } = await Vue.http.put(`${process.env.VUE_APP_API_URL}/invoice-validation/${id}/revalidate`);
      commit('REVALIDATE_SUCCESS', { body, id });
      return body;
    } catch (e) {
      commit('REVALIDATE_ERROR', e.body);
      console.log(e);
      return e;
    }
  },
  getSummary: async ({ commit }, { id }) => {
    try {
      commit('GET_SUMMARY_REQUEST', { id });
      const { body } = await Vue.http.get(`${process.env.VUE_APP_API_URL}/invoice-validation/${id}/summary`);
      commit('GET_SUMMARY_SUCCESS', { body, id });
      return body;
    } catch (e) {
      commit('GET_SUMMARY_ERROR', e.body);
      console.log(e);
      return e;
    }
  },
  forceValidate: async ({ commit }, { id }) => {
    try {
      commit('FORCE_VALIDATE_REQUEST', { id });
      const { body } = await Vue.http.put(`${process.env.VUE_APP_API_URL}/invoice-validation/${id}/force`);
      commit('FORCE_VALIDATE_SUCCESS', { body, id });
      return body;
    } catch (e) {
      commit('FORCE_VALIDATE_ERROR', e.body);
      console.log(e);
      return e;
    }
  },
  listInvoices: async ({ commit }, { id, data }) => {
    try {
      commit('LIST_INVOICES_REQUEST', { id });
      const { body } = await Vue.http.get(`${process.env.VUE_APP_API_URL}/invoices`, {
        ...(data || {}),
        params: {
          ...(data?.params || {}),
          invoiceValidationId: id
        }
      });
      commit('LIST_INVOICES_SUCCESS', { body });
      return body;
    } catch (e) {
      commit('LIST_INVOICES_ERROR', e.body);
      console.log(e);
      return e;
    }
  },
  getCounts: async ({ commit }) => {
    commit('GET_COUNTS_REQUEST');

    try {
      const [queue, passed, failed] = await Promise.all([
        Vue.http.get(`${process.env.VUE_APP_API_URL}/invoice-capture`, {
          params: {
            status: 'captured',
            invoiceValidationId: 'null',
            $select: '_id'
          }
        }),
        Vue.http.get(`${process.env.VUE_APP_API_URL}/invoice-validation/queue`, {
          params: {
            status: 'passed',
            $select: '_id'
          }
        }),
        Vue.http.get(`${process.env.VUE_APP_API_URL}/invoice-validation/queue`, {
          params: {
            status: 'failed',
            $select: '_id'
          }
        })
      ]);

      const counts = {
        queue: queue.body.data.length,
        passed: passed.body.data.length,
        failed: failed.body.data.length
      };

      commit('GET_COUNTS_SUCCESS', counts);

      return counts;
    } catch (e) {
      commit('GET_COUNTS_ERROR', e.body);
      console.log(e);
      return e;
    }
  }
};
